import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef } from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { default as EmotionMediaSVG } from './media-svg';
import { default as CompiledMediaSVG } from './media-svg-compiled';
export { MediaSVGError } from './errors';
var MediaSVG = /*#__PURE__*/forwardRef(function (props, ref) {
  return fg('platform_media_compiled') ? /*#__PURE__*/React.createElement(CompiledMediaSVG, _extends({}, props, {
    ref: ref
  })) : /*#__PURE__*/React.createElement(EmotionMediaSVG, _extends({}, props, {
    ref: ref
  }));
});
export default MediaSVG;
export { useResolveSvg } from './useResolveSvg';